module.exports = __webpack_public_path__ + "static/media/meeting-title-icon.7600aa17.svg";